import React from 'react'
import Modal from '../../components/ui/modal'
import Button from '../../components/ui/button'
import colors from '../../utils/colors'
import { Flex } from '@chakra-ui/react'


interface IProps {
  isOpen: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  image: string
  headerText: string
  subText: string
  btnText: string
  onclickProceed?: () => void
  doubleBtns?: boolean
  leftBtn?: JSX.Element
  rightBtn?: JSX.Element
  warning?: boolean
}

const AuthenticationModal = ({ isOpen, onClose, title, image, headerText, subText, btnText, onclickProceed, doubleBtns = false, leftBtn, rightBtn, warning }: IProps) => {
  return (
    <Modal isOpen={isOpen} hasClose={false} onClose={() => onClose(false)} title={title} className='w-[90%] md:w-[35%] md:min-w-[400px] max-w-[500px] p-[20px] md:p-[40px]'>
      <div className='mt-[15px] md:mt-[30px] flex w-full flex-col items-center gap-[12px] md:gap-[24px]'>
        <img src={image} className='w-[50px] h-[50px] md:w-[80px] md:h-[80px]' />
        <div className='font-[600] text-[16px] md:text-[28px] font-lexend leading-normal text-center' style={{ color: warning ? colors?.dark : colors.primary }}>
          {headerText}
        </div>
        <div className='font-[400] text-center text-[14px] md:text-[18px] font-lato leading-normal' style={{ color: colors.dark }}>
          {subText}
        </div>
        {
          doubleBtns ?
            <Flex w={"100%"} gap={"10px"}>
              {leftBtn}
              {rightBtn}
            </Flex> :
            <div className='flex items-center w-full justify-between'>
              <Button theme='primary' text={btnText} className='rounded-md w-full' size='md' onClick={onclickProceed} />
            </div>
        }

      </div>
    </Modal>
  )
}

export default AuthenticationModal